<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('contractor_reports.title')"/>
    <div class="col-12 mt-2 mb-3">
        <contract-report-filter
            :user="user"
            @search="fetchReports"
        />
    </div>
    <div v-if="noResults" class="col-sm-12">
      <span slot="noOptions">{{ $t('common.no_results') }}</span>
    </div>
    <div v-if="company" id="printContainer" class="report">
      <div class="header">
        <span class="title">{{ company.name }}</span>
      </div>
      <hr class="report-divider">
      <!-- Persons -->
      <div
        v-if="persons && persons.length > 0"
        class="col-sm-12 list-container"
      >
        <h3>{{ $t('contractor_reports.persons') }}</h3>
        <contractor-person-results
          :results="persons"
        />
      </div>
      <!-- Vehicles -->
      <div
        v-if="vehicles && vehicles.length > 0"
        class="col-sm-12 list-container"
      >
        <h3>{{ $t('contractor_reports.vehicles') }}</h3>
        <contractor-vehicle-results
          :results="vehicles"
        />
      </div>
      <div class="row print-only p-2 px-3">
        <span class="item-detail-text">{{ $t('common.printed') }} {{ $d(new Date()) }}</span>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'
import {downloadHelper} from '../mixins/DownloadMixin'
import {printHelper} from '../mixins/PrintMixin'
import {vehicleHelper} from '../mixins/VehicleMixin'
import {Printd} from 'printd'
import ContractReportFilter from "@/components/contractorreport/ContractorReportFilter";
import ContractorPersonResults from "@/components/contractorreport/ContractorPersonResults";
import ContractorVehicleResults from "@/components/contractorreport/ContractorVehiclesResults";
import Navbar from "@/components/utils/Navbar";
import {inject} from "vue";

export default {
    name: 'ContractorReports',
    components: {Navbar, ContractorVehicleResults, ContractorPersonResults, ContractReportFilter},
    mixins: [restApi, timeUtils, downloadHelper, printHelper, vehicleHelper],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            company: null,
            persons: [],
            vehicles: [],
            loading: false,
            noResults: false
        }
    },
    mounted() {
        this.d = new Printd()
    },
    methods: {
        fetchReports: function (params) {
            this.noResults = false
            this.persons = []
            this.vehicles = []
            this.company = null
            if (params.contractorId) {
                this.loading = true
                if (parseInt(params.activeUsers) !== 1) {
                    this.restFetch(this.contractorReportUrl + "/" + params.contractorId, this.handleResponse, this.fail)
                } else {
                    this.restFetchParams(this.contractorReportUrl + "/" + params.contractorId, {activeUsers: params.activeUsers},
                        this.handleResponse, this.fail)
                }
            }
        },
        handleResponse: function (response) {
            this.loading = false
            if (!response.data || response.data.length < 1) {
                this.noResults = true
            } else {
                this.company = response.data.company
                this.persons = response.data.persons
                this.vehicles = response.data.vehicles
            }
        },
        fail: function () {
            this.loading = false
            this.showAlert(this.$t('trip_list.err_general'))
        },
        print: function () {
            if (!this.loading) {
                this.d.print(document.getElementById('printContainer'), this.printStyle)
            }
        }
    }
}
</script>
